import type { IState } from '../reducers/metadata';
import { getMetadata } from '../selectors/metadata';

import { useAppSelector } from './redux';

export const useMetadata = (pathname: string): IState['data'][string] => useAppSelector(getMetadata(pathname));
